import { useMutation, useQuery, useQueryClient } from "react-query";
import { CreateVenue, Venue } from "../models/Venue";
import { useBackendMutationFunction } from "./common/useBackendMutationFunction";
import { useBackendQueryFunction } from "./common/useBackendQueryFunction";
import { UrlQuery } from "./common/useBackendUrl";

export const GetVenuesKey = "GetVenues";

interface UseGetVenueProps extends UrlQuery {
  id: string;
}

export function useGetVenue(props: UseGetVenueProps) {
  const queryFn = useBackendQueryFunction<Venue>("/venues/:id", props);

  return useQuery<Venue>([GetVenuesKey, props], queryFn);
}

export function useGetVenues() {
  const queryFn = useBackendQueryFunction<Venue[]>("/venues");

  return useQuery<Venue[]>([GetVenuesKey], queryFn);
}

interface UseDeleteVenueProps extends UrlQuery {
  venueId: string;
}
export function useDeleteVenue(props: UseDeleteVenueProps) {
  const mutationFn = useBackendMutationFunction<Venue, void>(
    "/venues/:venueId",
    "DELETE",
    props
  );
  const queryClient = useQueryClient();
  return useMutation(mutationFn, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(GetVenuesKey);
    },
  });
}

export function usePostVenue() {
  const mutationFn = useBackendMutationFunction<Venue, CreateVenue>(
    "/venues",
    "POST"
  );
  const queryClient = useQueryClient();
  return useMutation(mutationFn, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(GetVenuesKey);
    },
  });
}

export function usePatchVenue() {
  const mutationFn = useBackendMutationFunction<Venue, Venue>(
    "/venues",
    "PATCH"
  );
  const queryClient = useQueryClient();
  return useMutation(mutationFn, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(GetVenuesKey);
    },
  });
}
